function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from "react";
import { PREFETCH_TYPES } from "constants/prefetch-constants";
const PREFETCHED_DOMAINS = [
    "https://views.monday.com"
];
const PRECONNECT_DOMAINS = PREFETCHED_DOMAINS;
const PrefetchedLiveBoardAssetsContext = /*#__PURE__*/ createContext("PrefetchedLiveBoardAssets");
export const PrefetchLiveBoardAssetsProvider = (props)=>{
    const { children } = props;
    const [prefetchedLiveBoardAssetsLinks, setPrefetchedLiveBoardAssetsLinks] = useState([]);
    useEffect(()=>{
        const setData = function() {
            var _ref = _async_to_generator(function*() {
                const LiveBoardAssetsLinks = [];
                // dns prefetches
                PREFETCHED_DOMAINS.forEach((href)=>{
                    LiveBoardAssetsLinks.push({
                        type: PREFETCH_TYPES.DNS_PREFETCH,
                        href
                    });
                });
                // pre-connects
                PRECONNECT_DOMAINS.forEach((href)=>{
                    LiveBoardAssetsLinks.push({
                        type: PREFETCH_TYPES.PRECONNECT,
                        href
                    });
                });
                setPrefetchedLiveBoardAssetsLinks(LiveBoardAssetsLinks);
            });
            return function setData() {
                return _ref.apply(this, arguments);
            };
        }();
        setData();
    }, []);
    return /*#__PURE__*/ _jsx(PrefetchedLiveBoardAssetsContext.Provider, {
        value: prefetchedLiveBoardAssetsLinks,
        children: children
    });
};
export const usePrefetchedLiveBoardAssets = ()=>{
    const prefetchedLiveBoardAssetsLinks = useContext(PrefetchedLiveBoardAssetsContext);
    return prefetchedLiveBoardAssetsLinks;
};
